<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Editar cliente</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="submit">
                            <div class="row">
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Documento de identidad</label
                                    >
                                    <argon-input id="code"
                                    type="text" v-model="client.document" 
                                    />
                                    <small v-if="submitted && v$.client.document.$error" class="text-danger">Documento de identidad es requerido</small>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Tipo de cliente</label
                                    >
                                    <argon-select class="form-control" type="text" v-model="client.client_type" :choices="type"/>
                                </div>
                                <div class="col-md-12">
                                    <label for="example-text-input" class="form-control-label"
                                    >Nombres y Apellidos</label
                                    >
                                    <argon-input id="code"
                                    type="text" v-model="client.name" 
                                    />
                                    <small v-if="submitted && v$.client.name.$error" class="text-danger">Nombre y apellido es requerido</small>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Sexo</label
                                    >
                                    <argon-select class="form-control" type="text" v-model="client.sex" :choices="sex"/>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Fecha de nacimiento</label
                                    >
                                    <VueDatePicker type="text" v-model="client.birth_date" 
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    :min-date="minCfgDate" :max-date="maxCfgDate"
                                    :enable-time-picker="false" auto-apply/>
                                </div>
                                
                                <div class="col-md-12">
                                    <label for="example-text-input" class="form-control-label"
                                    >Dirección</label
                                    >
                                    <argon-textarea type="text" v-model="client.address"/>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Teléfono</label
                                    >
                                    <argon-input id="code"
                                    type="text" v-model="client.phone" 
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Correo</label
                                    >
                                    <argon-input id="code"
                                    type="text" v-model="client.email" 
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Nivel académico</label
                                    >
                                    <argon-select class="form-control" type="text" v-model="client.education" :choices="education"/>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Profesión/Oficio</label
                                    >
                                    <argon-select class="form-control" type="text" v-model="client.profession" :choices="profession"/>
                                </div>
                                <div class="col-md-6">
                                    <div>
                                    <label for="example-text-input" class="form-control-label"
                                    >Parte Frontal de documento de identidad</label
                                    ></div>
                                    <div>
                                        <img :src="client.document_front_url ? client.document_front_url : fileUpload" style="max-width:50%;" class="mx-auto" @click="uploadPhoto('documentFront')" ref="clientFront"/>
                                        <input type="file" style="display: none !important;" ref="clientFrontFile" accept="image/jpeg, image/png" @change="onFileChange('front', $event)">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div><label for="example-text-input" class="form-control-label"
                                    >Parte Trasera de documento de identidad</label
                                    ></div>
                                    <div>
                                        <img :src="client.document_back_url ? client.document_back_url : fileUpload" style="max-width:50%;" class="mx-auto" @click="uploadPhoto('documentBack')" />
                                        <input type="file" style="display: none !important;" ref="clientBackFile" accept="image/jpeg, image/png" @change="onFileChange('back', $event)">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div><label for="example-text-input" class="form-control-label"
                                    >Foto del cliente</label
                                    ></div>
                                    <div>
                                        <img :src="client.photo_url ? client.photo_url : fileUpload" style="max-width:50%;" class="mx-auto" @click="uploadPhoto('photo')" />
                                        <input type="file" style="display: none !important;" ref="clientPhotoFile" accept="image/jpeg, image/png" @change="onFileChange('photo', $event)">
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label for="example-text-input" class="form-control-label"
                                    >DATOS LABORALES</label
                                    >
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Lugar de trabajo</label
                                    >
                                    <argon-input id="code"
                                    type="text" v-model="client.work_name" 
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Teléfono del trabajo</label
                                    >
                                    <argon-input id="code"
                                    type="text" v-model="client.work_phone" 
                                    />
                                </div>
                                <div class="col-md-12">
                                    <label for="example-text-input" class="form-control-label"
                                    >Dirección del trabajo</label
                                    >
                                    <argon-input id="code"
                                    type="text" v-model="client.work_address" 
                                    />
                                </div>
                            </div>

                            <argon-button
                            type="submit" 
                            class="mt-4"
                            color="success"
                            fullWidth
                            size="lg"
                            @click="insertClient"
                            >Guardar</argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ArgonInput from "@/components/ArgonInput.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ArgonSelect from "@/components/ArgonSelect.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import {useVuelidate} from '@vuelidate/core';
import {required} from  '@vuelidate/validators';
import axios from "axios";
import fileUpload from'@/assets/img/uploadfile.jpg';
export default {
    name: "company",
    setup:() => ({ v$: useVuelidate() }), 
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setFullYear(1900)
        minDate.setMonth(minDate.getMonth() - 2)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate()+1)
        return {
            fileUpload,
            showMenu: false,
            submitted:false,
            maxCfgDate:maxDate,
            minCfgDate:minDate,
            testClasifications:[],
            testTypes:[],
            client:{
                document:null,
                name:null,
                birth_date:now,
                sex:1,
                address:null,
                email:null,
                phone:null,
                client_type:1,
                education:0,
                profession:0,
                company_id:1,
                qualification:"A",
                state:1,
                work_name:null,
                work_address:null,
                work_phone:null,
                photo_url:null,
                document_front_url:null,
                document_back_url:null,
                //created_date:now
            },
            sex:[
                {value:1,text:'Masculino'},
                {value:2,text:'Femenino'}
            ],
            type:[
                {value:1,text:'Persona Natural Nacional'},
                {value:2,text:'Persona Natural Extranjera'},
                {value:3,text:'Persona Jurídica Nacional'},
                {value:4,text:'Persona Jurídica Extranjera'},
            ],
            education:[
                {value:0,text:'Ejemplo'},
            ],
            profession:[
                {value:0,text:'Ejemplo'},
            ],
        };
    },
    components: {
        ArgonInput, 
        VueDatePicker,
        ArgonButton, 
        ArgonTextarea, 
        ArgonSelect,
    },
    validations(){
        return{
            client:{
                document:{required},
                name:{required},
                birth_date:{required},
            },
        }
    },
    methods:{
        fetchClientData(config){
            let self=this;
            fetch(this.$store.state.apiURL+'view/clients/'+this.$route.params.id, config)
            .then(response=>response.json())
            .then(result=> {
                console.log(result); 
                this.client=result.clients;
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#0b9257',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        },
        uploadPhoto(e){
            console.log(e);
            if(e=='documentFront'){
                this.$refs.clientFrontFile.click();
            }else if(e=='documentBack'){
                this.$refs.clientBackFile.click();
            }else{
                this.$refs.clientPhotoFile.click();
            }
        },
        onFileChange(type, event){
            let self=this;
            const file = event.target.files[0];
            console.log(file)
            let formData=new FormData();
            let fileU;
            let filename='jpg';
            if(file){
                fileU=URL.createObjectURL(file);
                console.log(fileU);
                formData.append('file', file);
                formData.append('fileName', filename);
                axios.post(this.$store.state.fileURL, formData,
                    {
                    headers: {
                        "Authorization": "Basic cHJpdmF0ZV9XVXVROG1DQncxV210WHc1empIa3NGQkNZQ1E9Og==",
                        'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'
                    }
                }).then(function(result){
                    console.log(result);
                    if(type=='front'){
                        self.client.document_front_url=result.data.url;
                    }else if(type=='back'){
                        self.client.document_back_url=result.data.url;
                    }else{
                        self.client.photo_url=result.data.url;
                    }
                })
            }
        },
        insertClient(){
            let self= this;
            this.submitted = true;
            this.v$.$touch();
            if(!this.v$.$invalid){
                const token = localStorage.getItem("accessToken");
                const config = {headers: {"X-Authorization": `Bearer ${token}`}};
                console.log(this.client)
                const date = new Date(this.client.birth_date);
                this.client.birth_date = date.toISOString().split('T')[0];
                axios.post(this.$store.state.apiURL+'edit/clients/'+this.$route.params.id, this.client, config)
                .then((result)=>{
                    console.log(result);
                    self.$swal({
                        title: 'Actualización de datos',
                        text: 'Se insertó la información del cliente de manera satisfactoria',
                        type: 'success',
                        icon:'success',
                        showCancelButton: false,
                        confirmButtonColor:'#0b9257',
                        showCloseButton: true,
                        showLoaderOnConfirm: false  
                    }).then(function(){
                        self.$router.push('/clients');
                    });
                    
                })
            }else{
                self.$swal({
                    title: 'Error en validación',
                    text: 'Encontramos algunos datos incorrectos',
                    type: 'error',
                    icon:'error',
                    showCancelButton: false,
                    confirmButtonColor:'#0b9257',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                });
            } 
            
        },
    },
    mounted() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchClientData(config);
        //this.fetchTestTypes(config);
    },
    beforeMount() {

    },
    beforeUnmount() {

    }
};
</script>